import { render, staticRenderFns } from "./FootFixed.vue?vue&type=template&id=53425e4f&scoped=true&"
import script from "./FootFixed.vue?vue&type=script&lang=js&"
export * from "./FootFixed.vue?vue&type=script&lang=js&"
import style0 from "./FootFixed.vue?vue&type=style&index=0&id=53425e4f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53425e4f",
  null
  
)

export default component.exports